import type { Currency } from '@/common/db-typebox/user-profile.typebox';

// Currency symbol mapping
export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  USD: '$',
  EUR: '€',
  CNY: '¥',
  GBP: '£',
  JPY: '¥',
  NTD: 'NT$',
};

// Currency price range configuration
export const CURRENCY_PRICE_RANGES: Record<
  Currency,
  { min: number; max: number }
> = {
  USD: { min: 0, max: 1000000 },
  EUR: { min: 0, max: 900000 },
  CNY: { min: 0, max: 7000000 },
  GBP: { min: 0, max: 800000 },
  JPY: { min: 0, max: 150000000 },
  NTD: { min: 0, max: 30000000 },
};

export const CURRENCY_OPTIONS: { value: Currency; label: string }[] = [
  { value: 'USD', label: `${CURRENCY_SYMBOLS.USD} - US Dollar (USD)` },
  { value: 'CNY', label: `${CURRENCY_SYMBOLS.CNY} - Chinese Yuan (CNY)` },
  { value: 'NTD', label: `${CURRENCY_SYMBOLS.NTD} - New Taiwan Dollar (NTD)` },
  { value: 'EUR', label: `${CURRENCY_SYMBOLS.EUR} - Euro (EUR)` },
  { value: 'GBP', label: `${CURRENCY_SYMBOLS.GBP} - British Pound (GBP)` },
  { value: 'JPY', label: `${CURRENCY_SYMBOLS.JPY} - Japanese Yen (JPY)` },
];

export function getCurrencySymbol(currency: Currency): string {
  return CURRENCY_SYMBOLS[currency] || '$';
}

export function formatPrice(
  price: number | null | undefined,
  currency: Currency,
) {
  if (price == null || price === -1 || price === 0) {
    return 'N/A';
  }

  const symbol = getCurrencySymbol(currency);

  // Special handling for decimal points based on currency
  if (currency === 'JPY') {
    // Japanese Yen typically doesn't show decimal points
    return `${symbol}${Math.round(price)}`;
  }

  return `${symbol}${price.toFixed(2)}`;
}
